import * as session from 'smg/customer-api/session';
import { CategoryDescriptionsFromDocument, InitEmailPreferencesPanel } from 'smg/email-preferences-page';
import { InitSmsPreferencesPanel } from 'smg/sms-preferences-panel';
import { AccountReady } from '../account-session';

void main();

async function main() {
    if (await AccountReady) {
        return;
    }

    // The current-user read the shared modules make carries the preferences,
    // not the number texts go to; the session is the one source of that here.
    const user = await session.Session().then(sess => sess.user);

    InitEmailPreferencesPanel({ mode: 'session', categoryDescriptions: CategoryDescriptionsFromDocument() });
    InitSmsPreferencesPanel({
        mode: 'session',
        phone: user.phoneNumber.phone ?? '',
        categoryDescriptions: CategoryDescriptionsFromDocument('#sprefs-categories'),
    });

    // Both channels load the same account, so the page carries one failure
    // notice with one Try again (the theme reveals it from either module's
    // load-failed block). Retrying only the channel that failed keeps a
    // healthy channel from repainting over a save it may have in flight.
    const $retry = document.querySelector('#nprefs-retry') as HTMLButtonElement;
    const channels = [
        { $failed: document.querySelector('#eprefs-load-failed') as HTMLElement, $retry: document.querySelector('#eprefs-retry') as HTMLButtonElement },
        { $failed: document.querySelector('#sprefs-load-failed') as HTMLElement, $retry: document.querySelector('#sprefs-retry') as HTMLButtonElement },
    ];
    $retry.addEventListener('click', () => {
        for (const channel of channels) {
            if (!channel.$failed.classList.contains('d-none')) {
                channel.$retry.click();
            }
        }
    });
}
